import React, { useRef,useEffect, useState } from "react";
import axios from "axios";
import Select from 'react-select'; // Import react-select
import { Link } from 'react-router-dom';
import { allschoolsListing, schoolPublicurl, allschoolsListingfilter,allschools } from "../../apis/urls";
import { Loader } from "rsuite";
import { $ } from "react-jquery-plugin";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import  "../../css/style-new.css";
import schoolicon from "../../images/school-icon.jpg";
import permissionicon from "../../images/permission-icon.jpg";
import adminstafficon from "../../images/admin-staff-icon.jpg";
import { decode } from "html-entities";
import generatePDF from '../schools/schooldirectorypdf';
import { useCallback } from 'react';

const ListofSchool = () => {
    
  // useEffect(() => {
       
  //       fetchSchoolList();
  //   }, []);

  useEffect(() => {
    $('body').removeClass('').addClass('sidebar-collapsed');
    $('html,body').animate({ scrollTop: 0 }, 'fast');
    //setLoader(true);
    // schoolListing();
    fetchSchoolList();
    setTimeout(() => {
        Listing();
        Listingall();
    });

}, []);

    const [schools, setSchools] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [res, setRes] = useState([]);
    const [loader, setLoader] = useState(false);

    const [toggle, setToggle] = useState(true)
   
    const pdfRef = useRef(null);

    const todays = new Date();
    
    const [pdfDatas, setPdfDatas] = useState([]);
    const [schoolName, setSchoolName] = useState('');
    
    const [schoolId, setSchoolId] = useState(0);
    const toggleOpenButton = () => 
        {
            $('body').removeClass('').addClass('sidebar-collapsed sidebar-active');
            setToggle(false)
        };
        const toggleCloseButton = () => 
            {
                $('body').removeClass('sidebar-active').addClass('');
                setToggle(true)
    
            };

    
    const [result, setResult] = useState([]);
    const [resultall, setResultall] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    

    const [hasSearched, setHasSearched] = useState(false);
    const [showSearch, setShowSearch] = useState(true);
    const [isSearching, setIsSearching] = useState(false);
    const [isDropdownSelected, setIsDropdownSelected] = useState(false);
    
    

    let token = "Bearer " + localStorage.getItem('token');

    const Listing = () => {
      const instance = axios.create({
          baseURL: allschoolsListing + '?search=',
          timeout: 1000000,
          //headers: { 'authorization': token }
      });

      instance.get('').then((response) => {
          console.log("Response data is", response.data);
          setResult(response.data.data);
          setLoader(false);
      }).catch((error) => {
          console.log('Error', error.message);
      });
  };

  

  const instances = axios.create({
      baseURL: allschoolsListing,
      timeout: 1000000,
      //headers: { 'authorization': token }
  });

  const schoolListing = () => {
      const instance = axios.create({
          baseURL: schoolPublicurl,
          timeout: 1000000
      });

      instance.get('').then(res => {
          setRes(res.data.data);
          console.log("datas", res.data.data);
      }).catch((error) => {
          console.log('error', "failed in school");
      });
  };

  const findByTitles = name => {
      return instances.get(`?search=${name}`);
  };
   
    // Fetch all schools for the dropdown
    // const fetchSchoolList = async () => {
    //     try {
    //         const response = await axios.get(schoolPublicurl);
    //         const schoolOptions = response.data.data.map(school => ({
    //             value: school.id,
    //             label: school.name
    //         }));
    //         setRes(schoolOptions);
    //     } catch (error) {
    //         console.log("Failed to fetch schools:", error);
    //     }
    // };

    // const handleSchoolChange = (selectedOption) => {
    //     if (selectedOption) {
    //         fetchSchoolDetails(selectedOption.value);
    //         setSelectedSchool(selectedOption);
    //     } else {
    //         setSelectedSchool(null);
    //     }
    // };

    // const fetchSchoolDetails = async (schoolId) => {
    //     try {
    //         const response = await axios.get(`${allschoolsListingfilter}/${schoolId}`);
    //         setSelectedSchool({
    //             ...selectedSchool,
    //             details: response.data.data
    //         });
    //     } catch (error) {
    //         console.log("Failed to fetch school details:", error);
    //     }
    // };

    const fetchSchoolList = async () => {
      try {
          const response = await axios.get(schoolPublicurl);
          const schoolOptions = response.data.data.map(school => ({
              value: school.id,
              label: decode(school.name)
          }));
          setRes(schoolOptions);
      } catch (error) {
          console.log("Failed to fetch schools:", error);
      }
  };

  const handleSchoolChange = async (selectedOption) => {
      setSelectedSchool(selectedOption);
      if (selectedOption) {
          await fetchSchoolDetails(selectedOption.value);
      }
  };

  const fetchSchoolDetails = async (schoolId) => {
      try {
          const response = await axios.get(`${allschoolsListingfilter}/${schoolId}`);
          setSelectedSchool(prevState => ({
              ...prevState,
              details: response.data.data
          }));
      } catch (error) {
          console.log("Failed to fetch school details:", error);
      }
  };

      const onChangeSearchTitle1 = (e) => {
        const searchTitle = e.target.value;
        setSearchTitle(searchTitle);
        setHasSearched(searchTitle.length > 0);
        findByTitles(searchTitle)
          .then(response => {
            if (response.data.message === "Success") {
              setResult(response.data.data);
            } else {
              setResult([]);
            }
          })
          .catch(e => {
            console.log(e);
          });
      };
    const onChangeSearchTitle = (e) => {
      setSearchTitle(e.target.value);
  };

    const performSearch = () => {
      
        setIsSearching(true);
        setHasSearched(true);
        findByTitles(searchTitle)
            .then(response => {
                if (response.data.message === "Success") {
                    setResult(response.data.data);
                } else {
                    setResult([]);
                }
                setIsSearching(false);
            })
            .catch(e => {
              setIsSearching(false);
                console.log(e);
                setResult([]);
            });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            performSearch();
        }
    };

    const Listingall = () => {
      const instance = axios.create({
          baseURL: allschools,
          timeout: 1000000,
          //headers: { 'authorization': token }
      });

      instance.get('').then((response) => {
          console.log("Response data is", response.data);
          setResultall(response.data.data);
          setLoader(false);
      }).catch((error) => {
          console.log('Error', error.message);
      });
    };


    const currentYear = new Date().getFullYear(); // Get the current year



    const decodeHtml = (input) => {
      const parser = new DOMParser();
      const decodedString = parser.parseFromString(input, 'text/html').documentElement.textContent;
      return decodedString;
    };
    const generatePDF = () => {
      const content = document.getElementById('school-directory-content');
      if (!content) {
        console.error('PDF content element not found');
        return;
      }

      const doc = new jsPDF('p', 'mm', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Set margins
      const marginTop = 20;
      const marginBottom = 20;
      const marginLeft = 10;
      const marginRight = 10;

      const contentWidth = pageWidth - marginLeft - marginRight;
      const contentHeight = pageHeight - marginTop - marginBottom;

      // Function to add page border and number
      const addPageBorderAndNumber = (page) => {
        doc.setDrawColor(0);
        doc.setLineWidth(0.5);
        doc.rect(5, 5, pageWidth - 10, pageHeight - 10);
        doc.setFontSize(10);
        doc.text(`Page ${page}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
      };

      // Split content into pages
      const splitContent = (element) => {
        let y = marginTop;
        let page = 1;
        addPageBorderAndNumber(page);
        let isInAdminStaffSection = false;
        let isFacultyListing = false;
        let isProcessingFacultyDetails = false;

        const processNode = (node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const style = window.getComputedStyle(node);
            const fontSize = parseFloat(style.fontSize);
            const normalLineHeight = fontSize * 0.5;
            const reducedLineHeight = fontSize * 0.3;
            const schoolHeadingLineHeight = fontSize * 0.3;
            const increasedLineHeight = fontSize * 0.2;
            const adminStaffSpacing = fontSize * 0.4;
            const schoolNameSpacing = fontSize * 0.8;
            const facultySpacing = fontSize * 0.6;
            const facultyDetailIndent = 10; // Indentation for faculty email and positions
            const facultyPositionIndent = 20;
            

            if (node.tagName === 'H1' || node.tagName === 'H2' || node.tagName === 'H3') {
              // Add extra space before school names (headings starting with a number)
              if (node.textContent.match(/^\d+\./)) {
                  y += schoolNameSpacing;
                }
      
                if (y + normalLineHeight > pageHeight - marginBottom) {
                  doc.addPage();
                  y = marginTop;
                  page++;
                  addPageBorderAndNumber(page);
                }
                
                doc.setFontSize(fontSize);
                doc.setFont(undefined, 'bold');
                
                if (node.textContent.trim() === 'ATHLETIC MANAGER') {
                  y += increasedLineHeight;
                }
                if (node.textContent.trim() === 'HOS') {
                  y += increasedLineHeight;
                }
                
                if (node.textContent.trim() === 'Admin/Staff') {
                  isInAdminStaffSection = true;
                  y += adminStaffSpacing; // Add space before Admin/Staff section
                } else if (node.textContent.match(/^\d+\./)) {
                  isInAdminStaffSection = false;
                }
                
                doc.text(node.textContent, marginLeft, y);
                
                if (node.textContent.match(/^\d+\./)) {
                  y += schoolHeadingLineHeight;
                } else if (node.textContent.trim() === 'Permissions') {
                  y += reducedLineHeight;
                } else {
                  y += normalLineHeight;
                }
                
                doc.setFont(undefined, 'normal');
            } else if (node.tagName === 'LI') {
              // Check if this is the start of a faculty listing
              if (node.textContent.match(/^\d+\./)) {
                if (isFacultyListing) {
                  y += facultySpacing;
                } else {
                  isFacultyListing = true;
                }
                isProcessingFacultyDetails = true;
              } else if (isProcessingFacultyDetails) {
                // This is a faculty detail (email or position)
                y += reducedLineHeight;
              }

              const words = node.textContent.split(' ');
              let line = '';
              let currentX = isProcessingFacultyDetails && !node.textContent.match(/^\d+\./) ? 
                            marginLeft + facultyDetailIndent : 
                            marginLeft;

                            // Determine the indentation level
        if (isProcessingFacultyDetails && !node.textContent.match(/^\d+\./)) {
          if (node.textContent.trim().startsWith('•')) {
            // This is a faculty position, apply more indent
            currentX += facultyPositionIndent;
          } else {
            // This is likely an email, apply less indent
            currentX += facultyDetailIndent;
          }
        }
              for (let word of words) {
                const testLine = line + word + ' ';
                const testWidth = doc.getStringUnitWidth(testLine) * fontSize / doc.internal.scaleFactor;
                if (testWidth > contentWidth - (isProcessingFacultyDetails ? facultyDetailIndent : 0)) {
                  if (y + normalLineHeight > pageHeight - marginBottom) {
                    doc.addPage();
                    y = marginTop;
                    page++;
                    addPageBorderAndNumber(page);
                  }
                  doc.setFontSize(fontSize);
                  doc.text(line, currentX, y);
                  y += normalLineHeight;
                  line = word + ' ';
                } else {
                  line = testLine;
                }
              }
              if (line.trim().length > 0) {
                if (y + normalLineHeight > pageHeight - marginBottom) {
                  doc.addPage();
                  y = marginTop;
                  page++;
                  addPageBorderAndNumber(page);
                }
                doc.setFontSize(fontSize);
                doc.text(line, currentX, y);
                y += normalLineHeight;
              }

              // Reset processing flag if this was the last detail of a faculty member
              if (isProcessingFacultyDetails && node.nextElementSibling && node.nextElementSibling.tagName !== 'LI') {
                isProcessingFacultyDetails = false;
              }
            } else if (node.tagName === 'P') {
              const words = node.textContent.split(' ');
              let line = '';
              for (let word of words) {
                const testLine = line + word + ' ';
                const testWidth = doc.getStringUnitWidth(testLine) * fontSize / doc.internal.scaleFactor;
                if (testWidth > contentWidth) {
                  if (y + normalLineHeight > pageHeight - marginBottom) {
                    doc.addPage();
                    y = marginTop;
                    page++;
                    addPageBorderAndNumber(page);
                  }
                  doc.setFontSize(fontSize);
                  doc.text(line, marginLeft, y);
                  y += normalLineHeight;
                  line = word + ' ';
                } else {
                  line = testLine;
                }
              }
              if (line.trim().length > 0) {
                if (y + normalLineHeight > pageHeight - marginBottom) {
                  doc.addPage();
                  y = marginTop;
                  page++;
                  addPageBorderAndNumber(page);
                }
                doc.setFontSize(fontSize);
                doc.text(line, marginLeft, y);
                y += normalLineHeight;
              }
            }

            for (let child of node.childNodes) {
              processNode(child);
            }
          }
        };

        processNode(element);
      };

      splitContent(content);
      doc.save('schools_directory.pdf');
    };

    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        borderRadius: '25px',
        border: '1px solid #ccc',
        boxShadow: state.isFocused ? '0 0 0 2px #ccc' : null,
        '&:hover': {
          border: '1px solid #ccc',
        },
      }),
      menu: (provided) => ({
        ...provided,
        borderRadius: '15px',
        overflow: 'hidden',
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#f8f9fa' : null,
        color: 'black',
        '&:hover': {
          backgroundColor: '#f8f9fa',
        },
      }),
    };

    return (
      <body className="sidebar-collapsed">
        <div className="wrapper">
            <aside className="left-side side-off-canvas">  
                <div className="navbar  sidenavbar school-filter-wrpr">
                  <ul className="nav">
                      <li>
                        <em className="search-wrpr" style={{display:'none'}}>
                          <input type="text" placeholder="Search Schools" value={searchTitle}
                                onChange={onChangeSearchTitle} className="form-control" />
                        </em>
                      </li>
                      <li className="">
                          <select className="form-control" onChange={handleSchoolChange}  style={{display:'none'}}>
                              <option value="">Select a school</option>
                                  {res.map((school, index) => (
                              <option key={index} value={school.id}>
                                  {decodeHtml(school.name)}
                              </option>
                                ))}
                          </select>
                      </li>
                      <li>
                        <a className="btn btn-round btn-white btn-download mt-5 form-control" style={{paddingLeft:'16px !important',background:'#efc93d',color:'black',justifyContent: 'space-between',display:'none'}} onClick={generatePDF}>
                          Download directory <i className="icon-download" style={{color:'black',top:'0px',position:'relative',marginRight:'0px'}}></i>
                        </a>
                      </li>
                  </ul>
                    
                </div>
            </aside>
            <aside className="right-side">
                <header>
                    <div className="title-and-userprofile-wrpr">
                        <div className="toggle-and-heading">
                            <div>
                              {toggle?<div>
                              <a onClick={toggleOpenButton} className="sidebar-toggler icon-menu1 phoneonly"></a>	
                              </div>:
                              <div>
                              <a onClick={toggleCloseButton} className="sidebar-toggler icon-menu1 phoneonly"></a>
                              </div>	
                              }
                            </div>
                            <h2>Directory Search</h2>
                        </div>
                        <div className="school-filter-wrpr desktoponly">
                    
                            <em className="search-wrpr" style={{display:'none'}}>
                                <input type="text" placeholder="Search Schools" value={searchTitle}
                                    onChange={onChangeSearchTitle} className="form-control" />
                            </em>
                            <select className="form-control selectschool" onChange={handleSchoolChange}  style={{display:'none'}}>
                                <option value="">Select a school</option>
                                    {res.map((school, index) => (
                                <option key={index} value={school.id}>
                                    {school.name}
                                </option>
                                  ))}
                            </select>
                            <a className="btn btn-round btn-white btn-download" onClick={generatePDF} style={{display:'none'}}>
                            Download directory <i className="icon-download"></i>
                            </a>  
                        </div>
                    </div>
                </header>

                <div className="content-area" style={{ marginTop: '0px' }}>
                    {!selectedSchool ? (
                        <div className="centered-search">
                            {/* Searchable dropdown using react-select */}
                            <Select
                                className="selectschool curved-select "
                                classNamePrefix="curved-select" 
                                options={res}
                                onChange={handleSchoolChange}
                                placeholder="Search School"
                                isClearable={true}
                                value={selectedSchool}
                               
                            />
                        </div>
                    ) : null}

                    {selectedSchool ? (
                      <div className="top-search">
                          {/* Searchable dropdown using react-select */}
                          <Select
                              className="selectschool curved-select"
                              classNamePrefix="curved-select"
                              options={res}
                              onChange={handleSchoolChange}
                              placeholder="Search School"
                              isClearable={true}
                              value={selectedSchool}
                              
                          />
                      </div>
                  ) : null}
                  <div className="container" id="schoolData">
                    {selectedSchool && selectedSchool.details ? (
                        <div>
                            <div className="row mt-5">
                                      <div className="col-md-12">
                                        <div className="card schoolname-card">
                                          <div className="icon">
                                            <img src={schoolicon} alt="School Icon" />
                                          </div>
                                          <div className="row">
                                            <div className="col-md-6">
                                             
                                              <h5 className="card-title">{decode(selectedSchool.details.name)}</h5>
                                              <p className="card-text">{selectedSchool.details.address_1} {selectedSchool.details.address_2}</p>
                                              <p className="card-text">{selectedSchool.details.city}, {selectedSchool.details.state} {selectedSchool.details.zip}</p>
                                              <p className="card-text" style={{display:'none'}}>
                                                  <a href={`mailto:${selectedSchool.details.email}`}>{selectedSchool.details.email}</a>
                                              </p>
                                              <p className="card-text">
                                                  Tel: <a href={`tel:${selectedSchool.details.phone}`}>{selectedSchool.details.phone}</a>
                                              </p>

                                              <p className="card-text">
                                                   Website: &nbsp;
                                                  <a href={selectedSchool.details.website.startsWith('http') ? selectedSchool.details.website : `http://${selectedSchool.details.website}`} target="_blank" rel="noopener noreferrer">
                                                     {selectedSchool.details.website}
                                                  </a>
                                              </p>
                                            </div>
                                            
                                            {/* Display Head of School and Athletic Manager */}
                                            <div className="col-md-6">
                                                {/* Filter and display Head of School */}
                                                {selectedSchool.details.school_faculties && 
                                                    selectedSchool.details.school_faculties.filter(faculty => 
                                                        faculty.faculty_multiple_positions.some(position => 
                                                            position.faculty_position.name === "Head of School"
                                                        )
                                                    ).length > 0 && (
                                                        <div>
                                                            <p><strong>Head of School:</strong></p>
                                                            <ul className="list-unstyled">
                                                                {selectedSchool.details.school_faculties.map(faculty => (
                                                                    faculty.faculty_multiple_positions.map((position, index) => (
                                                                        position.faculty_position.name === "Head of School" && (
                                                                            <li key={index}>
                                                                                <a className="card-link mb-1" href={`mailto:${faculty.email}`}>
                                                                                    {decode(faculty.title)} {decode(faculty.first_name)}  {decode(faculty.last_name)}
                                                                                </a> <br />
                                                                                <a className="card-link mb-1" href={`mailto:${faculty.email}`}>
                                                                                    {faculty.email}
                                                                                </a>
                                                                            </li>
                                                                            
                                                                        )
                                                                    ))
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )
                                                }
                                            
                                                {/* Filter and display Athletic Manager */}
                                                {selectedSchool.details.school_faculties && 
                                                    selectedSchool.details.school_faculties.filter(faculty => 
                                                        faculty.faculty_multiple_positions.some(position => 
                                                            position.faculty_position.name === "Athletic Director"
                                                        )
                                                    ).length > 0 && (
                                                        <div className="mt-3">
                                                            <p><strong>Athletic Director:</strong></p>
                                                            <ul className="list-unstyled">
                                                                {selectedSchool.details.school_faculties.map(faculty => (
                                                                    faculty.faculty_multiple_positions.map((position, index) => (
                                                                        position.faculty_position.name === "Athletic Director" && (
                                                                            <li key={index}>
                                                                                <a className="card-link mb-1" href={`mailto:${faculty.email}`}>
                                                                                    {decode(faculty.title)} {decode(faculty.first_name)} {decode(faculty.last_name)}
                                                                                </a> <br />
                                                                                <a className="card-link mb-1" href={`mailto:${faculty.email}`}>
                                                                                    {faculty.email}
                                                                                </a>
                                                                            </li>
                                                                        )
                                                                    ))
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )
                                                }
                                           
                                            </div>
                                            
                                          </div>
                                        </div>
                                      </div>

                                <div className="col-md-12 pt-3">
                                  <div className="card admin-staff-card">
                                      <div className="icon">
                                          <img src={adminstafficon} alt="Admin Staff Icon" />
                                      </div>
                                      <h5 className="card-title mb-4">Other Staff</h5>
                                      <div className="row">
                                          {selectedSchool.details.school_faculties && selectedSchool.details.school_faculties.length > 0 ? (
                                              selectedSchool.details.school_faculties
                                                  // Filter out faculty members who ONLY have "Head of School" or "Athletic Manager" roles
                                                  .filter(faculty => 
                                                      faculty.faculty_multiple_positions.some(position => 
                                                          position.faculty_position.name !== "Head of School" && 
                                                          position.faculty_position.name !== "Athletic Director"
                                                      )
                                                  )
                                                  .map((faculty, fIndex) => (
                                                      <div className="col-md-4 staff-card" key={fIndex}>
                                                          <div className="card p-4 rounded-0">
                                                              <p className="card-text mb-1">
                                                                  <a className="card-link mb-1" href={`mailto:${faculty.email}`}>
                                                                      <strong>{decode(faculty.title)} {decode(faculty.first_name)} {decode(faculty.last_name)}</strong>
                                                                  </a>
                                                              </p>
                                                              <ul className="list-unstyled">
                                                                  {/* Show only roles that are NOT "Head of School" or "Athletic manager" */}
                                                                  {faculty.faculty_multiple_positions
                                                                      .filter(position => 
                                                                          position.faculty_position.name !== "Head of School" &&
                                                                          position.faculty_position.name !== "Athletic Director"
                                                                      )
                                                                      .map((position, pIndex) => (
                                                                          <li key={pIndex} style={{fontStyle:'italic'}}>• {decode(position.faculty_position.name)}</li>
                                                                      ))
                                                                  }
                                                              </ul>
                                                              <p className="card-text mb-1">
                                                                  <a className="card-link mb-1" href={`mailto:${faculty.email}`}>
                                                                      {faculty.email}
                                                                  </a>
                                                              </p>
                                                          </div>
                                                      </div>
                                                  ))
                                          ) : (
                                              <p>No Admin/Staff available.</p>
                                          )}
                                      </div>
                                  </div>
                              </div>

                              

                               
                                { /*<div className="col-md-12 pt-3">
                                    <div className="card admin-staff-card">
                                        <div className="icon">
                                            <img src={adminstafficon} alt="Admin Staff Icon" />
                                        </div>
                                        <h5 className="card-title mb-4">Admin Staff</h5>
                                        <div className="row">
                                            {selectedSchool.details.school_faculties && selectedSchool.details.school_faculties.length > 0 ? (
                                                selectedSchool.details.school_faculties.map((faculty, fIndex) => (
                                                    <div className="col-md-4 staff-card" key={fIndex}>
                                                        <div className="card p-4 rounded-0">
                                                            <p className="card-text mb-1">
                                                                <a className="card-link mb-1" href={`mailto:${faculty.email}`}>
                                                                    <strong>{faculty.title} {faculty.first_name} {faculty.middle_name} {faculty.last_name}</strong>
                                                                </a>
                                                            </p>
                                                            <ul className="list-unstyled">
                                                                {faculty.faculty_multiple_positions.map((position, pIndex) => (
                                                                    <li key={pIndex}>• {position.faculty_position.name}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <p>No Admin/Staff available.</p>
                                            )}
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    ) : null}
                  </div>
                </div>
            </aside>
            <div id="school-directory-content" ref={pdfRef} className="p-4" style={{ fontSize: '10px',display:'none' }}>
            <h1 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '16px' ,color:'red'}}>Schools Directory</h1>
            {resultall.map((school,index) => (
              <div key={school.id}  style={{ marginBottom: '32px', padding: '16px', borderRadius: '4px' }}>
                <h2 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>{index + 1}.{school.name}</h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div className="school-entry">
                  
                    <p>{school.address_1},{school.address_2}</p>
                    
                    <p>{school.city}, {school.state}, {school.zip}</p>
                    <p>{school.email}</p>
                    
                    {school.website && <p>{school.website}</p>}
                  </div>
                  
                </div>
                
                <div style={{ marginTop: '16px' }}>
      
    </div>
    
                
                {/* Check if there are any faculties */}
                {school.school_faculties.length > 0 && (
                  <div style={{ marginTop: '16px' }}>
                    <h3 style={{ fontSize: '12px', fontWeight: 'bold', display: 'none' }}></h3>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                      {school.school_faculties
                        .filter(faculty => faculty.faculty_multiple_positions && faculty.faculty_multiple_positions.length > 0) // Filter out faculties with empty or null faculty_multiple_positions
                        .map((faculty, index) => (
                          <ul key={faculty.id}>
                            <li>{index + 1}. {faculty.title} {faculty.first_name} {faculty.middle_name} {faculty.last_name}</li>
                            <br />
                            <li className="" style={{ marginLeft: '16px' }}>{faculty.email}</li>
                            <br />
                            <ul className="list-unstyled" style={{ marginLeft: '160px' }}>
                              {faculty.faculty_multiple_positions.map((position, pIndex) => (
                                <li key={pIndex}>• {position.faculty_position.name}</li>
                              ))}
                            </ul>
                          </ul>
                        ))}
                    </ul>
                  </div>
                )}
                
              </div>
            ))}
          </div>
        </div>
    </body>    
    );
};

export default ListofSchool;